(() => {
  if (!window.location.hash) {
    return;
  }

  try {
    document.querySelector(window.location.hash);

    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }
  } catch (e) {
    // noop
  }
})();
